import { ADSENSE_SEARCH_PAGE_TYPE } from './adsenseSearchPageType';
const VIP_ITEMS_COUNT = 1;
const LRP_ITEMS_COUNT = 1;
const ZRP_ITEMS_COUNT = 1;
export function adBlocksHelper(params) {
  const {
    pageType,
    bottomBlockContainerId,
    adLoadedCallback
  } = params;
  const bottomContainer = document.getElementById(bottomBlockContainerId);
  let firstAdBlock;
  let secondAdBlock;
  if (pageType === ADSENSE_SEARCH_PAGE_TYPE.LRP && bottomContainer) {
    const topContainer = document.getElementById(params.topBlockContainerId);
    if (topContainer) {
      firstAdBlock = {
        container: params.topBlockContainerId,
        width: topContainer.clientWidth,
        maxTop: LRP_ITEMS_COUNT,
        adLoadedCallback
      };
      secondAdBlock = {
        container: bottomBlockContainerId,
        width: bottomContainer.clientWidth,
        number: LRP_ITEMS_COUNT,
        adLoadedCallback
      };
    } else {
      firstAdBlock = {
        container: bottomBlockContainerId,
        width: bottomContainer.clientWidth,
        number: LRP_ITEMS_COUNT,
        adLoadedCallback
      };
    }
  }
  if (pageType === ADSENSE_SEARCH_PAGE_TYPE.ZRP && bottomContainer) {
    firstAdBlock = {
      container: bottomBlockContainerId,
      width: bottomContainer.clientWidth,
      number: ZRP_ITEMS_COUNT,
      adLoadedCallback
    };
  }
  if (pageType === ADSENSE_SEARCH_PAGE_TYPE.VIP && bottomContainer) {
    firstAdBlock = {
      container: bottomBlockContainerId,
      width: bottomContainer.clientWidth,
      number: VIP_ITEMS_COUNT,
      adLoadedCallback
    };
  }
  return {
    firstAdBlock,
    secondAdBlock
  };
}